import React, {useCallback, useContext, useState} from 'react'
import {WizardFormSelection} from './wizardForm/WizardFormSelection'
import {WizardContext} from './Wizard'
import {WizardForm} from './wizardForm/WizardForm'
import {WizardFormDesign} from './wizardForm/WizardFormDesign'
import {createOrder} from '../_redux/wizardCrud'
import {useHistory} from 'react-router-dom'
import {chekcInputSwal, confirmSwal, orderReceiptSwal, priceCheckSwal} from '../../../../util/Swals'
import k1utils from '../../../../util/k1utils'
import Swal from 'sweetalert2'
import {WORK_TYPE_BOOKN, WORK_TYPE_ORDER} from '../WizardConstants'

import {Modal} from 'react-bootstrap';

const validationValue = (keyData) => {
  // 고르지 않은 부분이 존재
  const noAnswerOrderValue = keyData.order_value.filter(
    (item) =>
      (item.musthave === 'Y' && item.t_item_optionidx === 0 && item.direct_text === '') ||
      (item.has_suboption === 'Y' &&
        item.musthave === 'Y' &&
        item.t_item_suboption_name === '' &&
        item.t_item_suboptionidx === 0)
  )
  // 디자인설명 공백
  const noAnswerReference = keyData.order_reference[0].contents === ''

  // 배송클릭
  const delivery = keyData.order_delivery
  const noAnswerDelivery =
    keyData.is_delivery === 'Y' &&
    (k1utils.isEmpty(delivery.to_name) ||
      k1utils.isEmpty(delivery.phone_number) ||
      k1utils.isEmpty(delivery.zipcode) ||
      k1utils.isEmpty(delivery.address1) ||
      k1utils.isEmpty(delivery.address2))

  let SwalContents = ''

  if (noAnswerOrderValue.length > 0)
    noAnswerOrderValue.forEach(
      (item, i, arr) =>
        (SwalContents +=
          arr.length - 1 === i ? item.t_order_item_name : `${item.t_order_item_name}, `)
    )

  if (noAnswerReference)
    SwalContents += SwalContents === '' ? '디자인설명' : noAnswerReference ? ', 디자인 설명' : ''

  const deliveryField = (keyList) => {
    let str = ''
    for (const key of keyList) {
      switch (key) {
        case 'to_name':
          if (k1utils.isEmpty(delivery[key])) str += str === '' ? '받으실분' : ', 받으실분'
          break
        case 'phone_number':
          if (k1utils.isEmpty(delivery[key])) str += str === '' ? '연락처' : ', 연락처'
          break
        case 'zipcode':
        case 'address1':
        case 'address2':
          if (k1utils.isEmpty(delivery[key]) && !str.includes('주소'))
            str += str === '' ? '주소' : ', 주소'
          break
        default:
          break
      }
    }

    return str
  }

  if (noAnswerDelivery)
    SwalContents +=
      SwalContents === ''
        ? '배송지 입력 (' + deliveryField(Object.keys(delivery)) + ')'
        : ', 배송지 입력 (' + deliveryField(Object.keys(delivery)) + ')'

  return SwalContents
}

export function WizardBody() {
  const {wizardForm, keyData, imgFiles, step, calStep, workTypeValue} = useContext(WizardContext)
  const typeName = workTypeValue !== 'ORDER' ? WORK_TYPE_BOOKN : WORK_TYPE_ORDER
  const history = useHistory()
  
  const [priceModal, setPriceModal] = useState(false);

  const checkInputValues = useCallback(() => {
    let SwalContents = validationValue(keyData)
    if (SwalContents !== '') {
      SwalContents += '은 필수사항입니다.'
      chekcInputSwal(SwalContents)
      return true
    } else if (keyData.order_status === 5090 && (keyData.price === 0 || isNaN(keyData.price))) {
      priceCheckSwal(workTypeValue)
      return true
    } else return false
  }, [keyData, workTypeValue])

  const onClick = useCallback(
    (e) => {
      if (checkInputValues()) return false
      // const insertData = addPrice();
      const formData = new FormData()
      formData.append('order', new Blob([JSON.stringify(keyData)], {type: 'application/json'}))

      imgFiles.forEach((file) => formData.append('files', file))

      if (calStep === 'false' && keyData.price_min === keyData.price_max) {
        keyData.price = keyData.price_max
        confirmSwal(keyData, workTypeValue).then(function(result) {
          if (result.value) {
            createOrder(formData)
              .then(() => {
                history.push(`/k/${keyData.order_key}`, {afterOrder: true})
              })
              .catch((error) => {
                console.error(error)
                Swal.fire({
                  title: typeName + '을 실패했습니다.',
                  html: '시스템 관리자에게 문의 바랍니다.',
                  icon: 'error',
                })
              })
          }
        })
      } else {
        orderReceiptSwal(workTypeValue).then(function(result) {
          if (result.value) {
            createOrder(formData)
              .then(() => {
                history.push(`/k/${keyData.order_key}`, {afterOrder: true})
              })
              .catch((error) => {
                console.error(error)
                Swal.fire({
                  title: typeName + '을 실패했습니다.',
                  html: '시스템 관리자에게 문의 바랍니다.',
                  icon: 'error',
                })
              })
          }
        })
      }
    },
    [keyData, imgFiles, history, checkInputValues, calStep, workTypeValue, typeName]
  )
  
  const openModal = () => {
    setPriceModal(true)
  }
  const clearModal = () => {
    setPriceModal(false)
  }


  const isPrd = () => {
    return (process.env.REACT_APP_DOMAIN === 'k1order.k1ple.com')
  }
  

  let deliveryPriceMin = 0
  let deliveryPriceMax = 0
  if (keyData.is_delivery === 'Y') {
    const item = keyData.order_value.find((item) => item.t_order_item_name === '배송 여부')
    deliveryPriceMin = item.price_min
    deliveryPriceMax = item.price_max
  }
  return (
    <>
    <div className={'row justify-content-center my-10 px-5 ' + (isPrd() ? 'd-none':'')} style={{height:'0'}}>
      <div className='col-xl-12 col-xxl-7'>
        <button
                  type='button'
                  className='btn btn-sm btn-info px-2 py-2 float-right'
                  onClick={openModal}>단가표</button>
      </div>
    </div>
    <div className='row justify-content-center my-10 px-5 my-lg-15 px-lg-10 '>
      <div className='col-xl-12 col-xxl-7'>
        {/*begin::WizardPage Form*/}
        <form className='form' id='kt_form'>
          <WizardForm />
          <WizardFormDesign />
          <WizardFormSelection />
          {/*begin::WizardPage Actions*/}
          {!(keyData.price_min === 0 && keyData.price_max === 0) && (
            <div>
              {`예상가격 : ${(
                keyData.price_min * (keyData.quantity ? keyData.quantity : 1)
              ).toLocaleString('ko-KR')} 
                            ~ 
                            ${(
                              keyData.price_max * (keyData.quantity ? keyData.quantity : 1)
                            ).toLocaleString('ko-KR')}`}
            </div>
          )}
          {keyData.is_delivery === 'Y' && (
            <div>
              {`배송비 : ${deliveryPriceMin.toLocaleString(
                'ko-KR'
              )} ~ ${deliveryPriceMax.toLocaleString('ko-KR')}`}
            </div>
          )}
          {!step && (
            <div className='d-flex justify-content-between border-top mt-5 pt-10'>
              <div className='mr-2'>
                <button
                  type='button'
                  className='btn btn-light-primary font-weight-bolder text-uppercase px-9 py-4'
                  data-wizard-type='action-prev'
                >
                  이전
                </button>
              </div>
              <div>
                {keyData?.order_status !== 5100 && (
                  <button
                    type='button'
                    className='btn btn-success font-weight-bolder text-uppercase px-9 py-4'
                    data-wizard-type='action-submit'
                    onClick={onClick}
                  >
                    {typeName} 접수하기
                  </button>
                )}
                <button
                  type='button'
                  className='btn btn-primary font-weight-bolder text-uppercase px-9 py-4'
                  data-wizard-type='action-next'
                >
                  다음
                </button>
              </div>
            </div>
          )}
          {/*end::WizardPage Actions*/}
        </form>
        {/*end::WizardPage Form*/}
      </div>
    </div>
    
    <Modal show={priceModal} onHide={clearModal}>
                    <div className='modali-content'>
                        <div className='modal-header'>
                            <h6 className='modal-title' style={{textAlign:"left"}}>단가표</h6>
                            <p className='modal-title' style={{textAlign:"right", fontSize:"12px", minWidth: "126px"}}>가격은 옵션에 따라 달라질 수 있습니다.</p>
                        </div>
                        <div className='modal-body' style={{textAlign: 'left', whiteSpace: 'pre-wrap'}}>
                            {wizardForm.map((step, i) => (
                              <table key={'step-' + i} className='table table-striped table-sm'>
                                {
                                  step.map((option, idx) => (
                                    <>
                                    { option.optionList && option.optionList.length > 0 && 
                                      <>
                                      <tr>{option.name}</tr>
                                      <tr>
                                        <table key={'option-' + idx} className='table table-striped table-sm'>
                                        {option.optionList.map((optionItem, optionItemIdx) => 
                                          (
                                            <>
                                            <tr key={'optionItemIdx-' + optionItemIdx}>
                                              <td style={{width:'50%'}}>{optionItem.name}</td>
                                            {/*
                                              <td style={{width:'25%', textAlign:'right'}} >{optionItem.price_min.toLocaleString('ko-KR')}</td>
                                              <td style={{width:'25%', textAlign:'right'}} >{optionItem.price_max.toLocaleString('ko-KR')}</td>
                                          */}
                                              <td></td>
                                              <td style={{width:'50%', textAlign:'right'}}>{(optionItem.price_min === 0 && optionItem.price_max === 0) ? '0' : ((optionItem.price_min + optionItem.price_max) / 2).toLocaleString('ko-KR')}</td>
                                            </tr>
                                            {
                                              optionItem.has_suboption === 'Y' &&
                                              <tr>
                                              <td style={{textAlign:'right'}}>옵션</td>
                                              <td style={{width:'50%'}} colSpan={2}>
                                              <table key={'suboption-' + optionItemIdx} style={{width:'100%'}}>
                                              {
                                                optionItem.suboption.map((suboptionItem, subOptionItemIdx) => 
                                                  (
                                                  <tr key={'suboptionItemIdx-' + subOptionItemIdx}>
                                                    <td style={{width:'50%'}}>{suboptionItem.name}</td>
                                                    {/*
                                                    <td style={{width:'25%', textAlign:'right'}} >{suboptionItem.price_min.toLocaleString('ko-KR')}</td>
                                                    <td style={{width:'25%', textAlign:'right'}} >{suboptionItem.price_max.toLocaleString('ko-KR')}</td>
                                                  */}
                                                  <td></td>
                                                  <td style={{width:'50%', textAlign:'right'}}>{(suboptionItem.price_min === 0 && suboptionItem.price_max === 0) ? '0' : ((suboptionItem.price_min + suboptionItem.price_max) / 2).toLocaleString('ko-KR')}</td>
                                                  </tr>
                                                  )
                                                )
                                              }

                                              </table>
                                              </td>
                                              </tr>
                                            }
                                            </>
                                          )
                                        )}
                                        </table>
                                      </tr>
                                      </>
                                    }
                                    </>
                                  ))
                                }
                              </table>
                              ))}

    
    
                            {/* <p>{JSON.stringify(wizardForm)}</p> */}
                        </div>
                        <div className='modal-footer'>
                            <button type='button' className='btn btn-light' onClick={() => {clearModal();}}>
                            닫기
                            </button>
                        </div>
                    </div>
    </Modal>
    </>
  )
}
